"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACTIVITIES_BY_CATEGORIES = exports.OUTDOOR_WALKING = exports.ERRORS = void 0;

var _types = require("../challenge/types");

var ERRORS = [{
  key: 'distance',
  match: ['distance does not exist']
}, {
  key: 'slow',
  match: ['SPEED_TOO_SLOW_FOR_WALKING']
}, {
  key: 'duration',
  match: ['NO_DURATION']
}, {
  key: 'conflict',
  match: ['CONFLICT']
}, {
  key: 'type',
  match: ['Activity type is not valid', 'Unsupported type']
}, {
  key: 'appSync',
  match: ['Activity before first app sync']
}, {
  key: 'tooLong',
  match: ['DISTANCE_TOO_LONG', 'DISTANCE_TOO_LONG_FOR_WALKING', 'DISTANCE_TOO_LONG_FOR_SWIMMING', 'DISTANCE_TOO_LONG_FOR_SKIING', 'DISTANCE_TOO_LONG_FOR_RUNNING', 'DISTANCE_TOO_LONG_FOR_CYCLING', 'DISTANCE_TOO_LONG_FOR_CROSS_COUNTRY_SKIING']
}, {
  key: 'appDisabled',
  match: ['app is not active']
}, {
  key: 'manualAlready',
  match: ['MANUAL_ACTIVITY_ALREADY_CREATED']
}, {
  key: 'manualTooLong',
  match: ['DURATION_TOO_LONG_FOR_SWIMMING_MANUAL', 'DURATION_TOO_LONG_FOR_WORKOUT_MANUAL']
}, {
  key: 'manual',
  match: ['MANUAL_ACTIVITY']
}, {
  key: 'distanceTooShort',
  match: ['DISTANCE_TOO_SHORT_FOR_SWIMMING', 'DISTANCE_TOO_SHORT_FOR_CYCLING', 'DISTANCE_TOO_SHORT_FOR_RUNNING', 'DISTANCE_TOO_SHORT_FOR_WALKING', 'DISTANCE_TOO_SHORT_FOR_SKIING', 'DISTANCE_TOO_SHORT_FOR_CROSS_COUNTRY_SKIING', 'DISTANCE_TOO_SHORT']
}, {
  key: 'ratioClimbDistance',
  match: ['RATIO_CLIMB_DISTANCE_INVALID']
}, {
  key: 'tooFast',
  match: ['SPEED_TOO_FAST', 'SPEED_TOO_FAST_FOR_WALKING', 'SPEED_TOO_FAST_FOR_SWIMMING', 'SPEED_TOO_FAST_FOR_SKIING', 'SPEED_TOO_FAST_FOR_RUNNING', 'SPEED_TOO_FAST_FOR_CYCLING', 'SPEED_TOO_FAST_FOR_CROSS_COUNTRY_SKIING']
}, {
  key: 'distanceTooLong',
  match: ['DURATION_TOO_LONG', 'DURATION_TOO_LONG_FOR_WALKING', 'DURATION_TOO_LONG_FOR_SWIMMING', 'DURATION_TOO_LONG_FOR_SKIING', 'DURATION_TOO_LONG_FOR_RUNNING', 'DURATION_TOO_LONG_FOR_CYCLING', 'DURATION_TOO_LONG_FOR_CROSS_COUNTRY_SKIING']
}, {
  key: 'maxActivity',
  match: ['MAX_NUMBER_OF_ACTIVITIES_PER_DAY']
}, {
  key: 'unsupportedActivityType',
  match: ['UNSUPPORTED_ACTIVITY_TYPE']
}];
exports.ERRORS = ERRORS;
var OUTDOOR_WALKING = 'OutdoorWalking';
exports.OUTDOOR_WALKING = OUTDOOR_WALKING;
var ACTIVITIES_BY_CATEGORIES = {
  Walking: ['Hiking', 'WalkWheelchair', 'Walking', 'OutdoorWalking'],
  Running: ['Athletics', 'Running', 'Treadmill', 'Wheelchair', 'RunWheelchair'],
  Cycling: ['Cycling', 'ElectricBike', 'Handbike', 'IndoorCycling', 'MountainBike'],
  WeightTraining: ['Aquagym', 'CardioTraining', 'Crossfit', 'Dance', 'EllipticalTrainer', 'IndoorRowing', 'StreetWorkout', 'WeightTraining', 'Workout'],
  Yoga: ['Meditation', 'PilateGym', 'Stretching', 'Yoga'],
  Basket: ['AmericanFootball', 'Baseball', 'Basketball', 'Cricket', 'Handball', 'Hockey', 'Netball', 'Petanque', 'Rugby', 'Soccer', 'Volleyball', 'WaterPolo'],
  Swimming: ['Kayaking', 'Kitesurf', 'Rowing', 'Windsurf', 'Swimming', 'Surf', 'ScubaDiving', 'SailAndBoard'],
  Snowboard: ['CrossCountrySkiing', 'IceSkating', 'SpeedSkating', 'Snowboard', 'Skiing'],
  Tennis: ['Tennis', 'TableTennis', 'Badminton', 'Padel', 'Squash'],
  Boxing: ['MartialArts', 'Fencing', 'Boxing'],
  Message: [_types.UserActionsType.FEED_MESSAGE, _types.UserActionsType.FEED_ACTIVITY_SHARE],
  MediaMessage: [_types.UserActionsTypeWithMedia.FEED_MESSAGE_WITH_MEDIA, _types.UserActionsTypeWithMedia.FEED_ACTIVITY_SHARE_WITH_MEDIA],
  Quiz: [_types.UserActionsType.QUIZ_COMPLETED]
};
exports.ACTIVITIES_BY_CATEGORIES = ACTIVITIES_BY_CATEGORIES;
//# sourceMappingURL=constants.js.map